import React, { useEffect, useState } from 'react';
import { Eye, MessageCircle, Phone, Heart, Share2, Calendar, Plus, Edit3, Trash2, UserPlus, LogIn, KeyRound, Mail, Building2 } from 'lucide-react';
import { api } from '../../lib/api';

// Map event_type → {Icon, sentence}
const RENDER = {
  'user.registered':      { Icon: UserPlus,  text: 'Te uniste a habita.co' },
  'user.logged_in':       { Icon: LogIn,     text: 'Iniciaste sesión' },
  'user.password_reset_requested': { Icon: KeyRound, text: 'Pediste recuperar contraseña' },

  'property.published':   { Icon: Plus,      text: 'Publicaste una propiedad' },
  'property.edited':      { Icon: Edit3,     text: 'Editaste una propiedad' },
  'property.deleted':     { Icon: Trash2,    text: 'Eliminaste una propiedad' },
  'property.viewed':      { Icon: Eye,       text: 'Tu propiedad recibió una visita' },
  'property.shared':      { Icon: Share2,    text: 'Tu propiedad fue compartida' },
  'property.favorited':   { Icon: Heart,     text: 'Tu propiedad fue agregada a favoritos' },

  'contact.whatsapp_clicked': { Icon: MessageCircle, text: 'Nuevo clic en WhatsApp' },
  'contact.phone_clicked':    { Icon: Phone,         text: 'Nuevo clic en teléfono' },
  'contact.email_clicked':    { Icon: Mail,          text: 'Nuevo clic en email' },
  'contact.message_sent':     { Icon: MessageCircle, text: 'Nuevo mensaje recibido' },
  'contact.visit_requested':  { Icon: Calendar,      text: 'Nueva solicitud de visita' },

  'agent.profile_viewed':     { Icon: Eye,           text: 'Tu perfil fue visitado' },
  'agent.whatsapp_clicked':   { Icon: MessageCircle, text: 'Clic en WhatsApp en tu perfil' },
  'agent.phone_clicked':      { Icon: Phone,         text: 'Clic en teléfono en tu perfil' },
  'agent.contacted':          { Icon: MessageCircle, text: 'Te enviaron un mensaje' },

  'agency.profile_viewed':    { Icon: Building2,     text: 'Visitaron el perfil de la inmobiliaria' },
  'agency.whatsapp_clicked':  { Icon: MessageCircle, text: 'Clic en WhatsApp en la inmobiliaria' },
  'agency.website_clicked':   { Icon: Building2,     text: 'Visitaron el sitio web de la inmobiliaria' },
  'agency.demo_requested':    { Icon: Building2,     text: 'Nueva solicitud de demostración' },
  'agency.lead_created':      { Icon: Building2,     text: 'Nuevo lead recibido' },
};

function timeAgo(iso) {
  if (!iso) return '';
  const diff = (Date.now() - new Date(iso).getTime()) / 1000;
  if (diff < 60) return 'ahora';
  if (diff < 3600) return `Hace ${Math.floor(diff / 60)} min`;
  if (diff < 86400) return `Hace ${Math.floor(diff / 3600)} h`;
  if (diff < 604800) return `Hace ${Math.floor(diff / 86400)} d`;
  return new Date(iso).toLocaleDateString('es-CO');
}

export default function ActivityFeed({ scope = 'mine', agencyId, title = 'Actividad reciente', limit = 20, testid = 'activity-feed' }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.getActivity(scope, agencyId)
      .then(d => setItems((d.items || []).slice(0, limit)))
      .catch(() => setItems([]))
      .finally(() => setLoading(false));
  }, [scope, agencyId, limit]);

  return (
    <div className="bg-white rounded-2xl border border-gray-200 p-5" data-testid={testid}>
      <p className="font-serif text-base font-bold text-habita-dark mb-3">{title}</p>
      {loading && <div className="py-8 text-center text-sm text-gray-500">Cargando…</div>}
      {!loading && items.length === 0 && (
        <div className="py-10 text-center" data-testid={`${testid}-empty`}>
          <Eye className="w-7 h-7 mx-auto text-gray-300" />
          <p className="text-sm text-gray-500 mt-3">Sin actividad reciente.</p>
          <p className="text-xs text-gray-400 mt-1">Aquí verás visitas, contactos y eventos cuando ocurran.</p>
        </div>
      )}
      <ul className="space-y-3">
        {items.map(ev => {
          const r = RENDER[ev.event_type] || { Icon: Eye, text: ev.event_type };
          const Icon = r.Icon;
          return (
            <li key={ev.id} className="flex items-start gap-3" data-testid={`${testid}-item-${ev.event_type}`}>
              <div className="w-8 h-8 rounded-full bg-habita-mint flex items-center justify-center shrink-0 mt-0.5">
                <Icon className="w-4 h-4 text-habita" />
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm text-habita-dark leading-snug">{r.text}</p>
                <p className="text-xs text-gray-500 mt-0.5">{timeAgo(ev.created_at)}</p>
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
